<template>
  <router-view/>
  <modals-container/>
</template>
